import { useCallback, useEffect, useState } from 'react';
import { Control, UseFormRegister, FieldErrors } from 'react-hook-form';

import { useAtom } from 'jotai';

import { getSchools } from '@/api/getSchools';
import InputText from '@/components/InputText/InputText';
import SelectField from '@/components/SelectField/SelectField';
import { UserAtom } from '@/jotai/jotai';
import { schoolGrades } from '@/logics/children/children';
import { UpdateChildFormData } from '@/pages/admin/children/[id]';
import { School } from '@/types/school';

type Props = {
  errors: FieldErrors<UpdateChildFormData>;
  control: Control<UpdateChildFormData>;
  register: UseFormRegister<UpdateChildFormData>;
};

export const ExternalContactsForm = ({ errors, control, register }: Props) => {
  const [schools, setSchools] = useState<School[]>([]);

  const [loginUser] = useAtom(UserAtom);

  const fetchSchools = useCallback(async () => {
    try {
      const result = await getSchools(loginUser?.email);
      if (result.status === 200) {
        setSchools(result.result);
      }
    } catch (error) {
      console.log('error');
    }
  }, [loginUser?.email]);

  useEffect(() => {
    fetchSchools();
  }, []);
  return (
    <div className="flex flex-col justify-center">
      <div className="flex flex-row gap-4">
        <SelectField
          name="schoolId"
          label="学校"
          control={control}
          items={schools.map((school) => ({
            label: school.name,
            value: school.id.toString(),
          }))}
          required={true}
        />
        <InputText
          label="学校TEL"
          type="text"
          required={true}
          errors={errors.schoolPhoneNumber}
          {...register('schoolPhoneNumber', { required: true })}
        />
      </div>
      <div className="w-1/2">
        <SelectField
          name="schoolGrade"
          label="学年"
          control={control}
          items={schoolGrades.map((schoolGrade) => ({
            label: schoolGrade,
            value: schoolGrade,
          }))}
          required={true}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="かかりつけ医（1）"
          type="text"
          required={false}
          {...register('doctorClinicName1')}
        />
        <InputText
          label="かかりつけ医（1）_TEL"
          type="text"
          required={false}
          {...register('doctorPhoneNumber1')}
        />
      </div>
      <div className="w-1/2">
        <InputText
          label="かかりつけ医（1）_主治医"
          type="text"
          required={false}
          {...register('doctorName1')}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="かかりつけ医（2）"
          type="text"
          required={false}
          {...register('doctorClinicName2')}
        />
        <InputText
          label="かかりつけ医（2）_TEL"
          type="text"
          required={false}
          {...register('doctorPhoneNumber2')}
        />
      </div>
      <div className="w-1/2">
        <InputText
          label="かかりつけ医（2）_主治医"
          type="text"
          required={false}
          {...register('doctorName2')}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="かかりつけ医（3）"
          type="text"
          required={false}
          {...register('doctorClinicName3')}
        />
        <InputText
          label="かかりつけ医（3）_TEL"
          type="text"
          required={false}
          {...register('doctorPhoneNumber3')}
        />
      </div>
      <div className="w-1/2">
        <InputText
          label="かかりつけ医（3）_主治医"
          type="text"
          required={false}
          {...register('doctorName3')}
        />
      </div>
    </div>
  );
};
